/****************************************************************************************************
*                                                                                                   *
*   Freshwater v3 CLIENT JS FILE                                                                    *
*                                                                                                   *
*   client specific scripts, this file CAN be edited                                                *
*                                                                                                   *
****************************************************************************************************/

window.addEventListener('load', function(e) {
    if (window.Freshwater) {
        window.Freshwater.console('log', "client js loaded. Event: " + e.type);
    }
    
});
